import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectComponent } from './select/select.component';
import { FormsModule } from '@angular/forms';
import { InputComponent } from './input/input.component';



@NgModule({
  declarations: [
    SelectComponent,
    InputComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    SelectComponent,
    InputComponent,
    SelectComponent
  ]
})
export class SharedModule { }
